import {
  DOWNLOAD_REQUEST,
  DOWNLOAD_SUCCEEDED,
  DOWNLOAD_FAILED,
} from "constants/actionTypes";

const initState = {
  downloading: false,
  downloaded: false,
  pagination: {
    currentPage: 0,
    totalPages: 0,
    recordsPerPage: 0,
    totalRecordsCount: 0,
  },
  items: [],
  completedPages: [],
  error: null,
};

function downloadsReducer(state = initState, action) {
  switch (action.type) {
    case DOWNLOAD_REQUEST: {
      const { page } = action.payload;

      let items = state.items;
      let completedPages = state.completedPages;
      let pagination = state.pagination;

      console.log("page", page);

      if (page === 0) {
        items = [];
        completedPages = [];
        pagination = initState.pagination;
      }

      return Object.assign({}, state, {
        ...state,
        downloading: true,
        downloaded: false,
        items: items,
        completedPages: completedPages,
        pagination: pagination,
        error: null,
      });
    }
    case DOWNLOAD_SUCCEEDED: {
      let result = action.payload;

      var items = result.records;
      if (result.currentPage !== 0) {
        items = [...state.items, ...result.records];
      }

      let downloading = result.currentPage + 1 < result.totalPages;

      return Object.assign({}, state, {
        ...state,
        downloading: downloading,
        downloaded: !downloading,
        items: items,
        pagination: {
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          recordsPerPage: result.recordsPerPage,
          totalRecordsCount: result.totalRecordsCount,
        },
        completedPages: [...state.completedPages, result.currentPage],
        error: null,
      });
    }
    case DOWNLOAD_FAILED: {
      return Object.assign({}, state, {
        ...state,
        downloading: false,
        downloaded: false,
        items: [],
        pagination: {
          currentPage: 0,
          totalPages: 0,
          recordsPerPage: 0,
          totalRecordsCount: 0,
        },
        error: action.payload,
      });
    }
    default:
      return state;
  }
}

export { downloadsReducer };
